import {
	comMapping
} from '../../../../util/Function/comMapping.js'
export function getdata() {
	var obj = {
		searchlist: [{
				prop: "companyCode",
				label: '公司代码',
				type: "input"
			},
			{
				prop: "suosq",
				label: '所属期',
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				prop: "fapdm",
				label: '发票代码',
				type: "input"
			},
			{
				prop: "faphm",
				label: '发票号码',
				type: "input",
			},
			{
				prop: "shudzphm",
				label: '数电发票号码',
				type: "input",
			},
			{
				prop: "kaiprq",
				label: '开票日期',
				type: "datemonth",
				valueformat: 'yyyy-MM-dd'
			},
			{
				prop: "kaiplx",
				label: '开票类型',
				type: "select",
				selectval: comMapping.$Faplx
			},

		],
		searchdata: {
			companyCode: "",
			suosq: "",
			fapdm: "",
			faphm: "",
			shudzphm: "",
			kaiprq: "",
			faplx: ""
		},
		headData: [{
				title: "公司代码",
				prop: "companyCode",
				width: 80,
				custom:true,

			},
			{
				title: "所属期",
				prop: "suosq",
				width: 80,
				custom:true,

			},
			{
				title: "发票代码",
				prop: "fapdm",
				custom:true,
				width: 110
			},
			{
				title: "发票号码",
				prop: "faphm",
				custom:true,
				width: 80
			},
			{
				title: "数电发票号码",
				prop: "shudzphm",
				custom:true,
				width: 80
			},
			{
				title: "开票日期",
				prop: "kaiprq",
				custom:true,
				width: 80
			},
			{
				title: "开票类型",
				prop: "faplx",
				custom:true,
				width: 80
			},
			{
				title: "含税金额合计",
				prop: "hansje",
				width: 110,
				AmountFormat: true,
				custom:true,
				
			},
			{
				title: "未税金额合计",
				prop: "weisje",
				custom:true,
				width: 110,
				AmountFormat: true,
				
			},
			{
				title: "税额合计",
				prop: "shuiehj",
				width: 80,
				AmountFormat: true,
				custom:true,
				
			},
			{
				title: "记账标志",
				prop: "jizbz",
				width: 80,
				custom:true,

			},
			{
				title: "抵扣标志",
				prop: "dikbz",
				width: 80,
				custom:true,

			},
			{
				title: "抵扣税额",
				prop: "dikse",
				custom:true,
				width: 80,
				AmountFormat: true,
				
			},
			{
				title: "批次号",
				prop: "pich",
				custom:true,
				width: 160,
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		syncFormDeductDefault: {
			issueDate: '',
			issueStart: '',
			issueEnd: ''
		},
		syncFormDefault: {
			issueDate: '',
			invoiceType: '',
			invoiceStatus: '',
			issueStart: '',
			issueEnd: ''
		}
	}
	return obj
}
